<template>
    <div class="admin-view">
      <AdminPanel />
    </div>
  </template>
  
  <script>
  import AdminPanel from '../components/AdminPanel.vue'
  
  export default {
    name: 'AdminView',
    components: {
      AdminPanel
    }
  }
  </script>